import React, { Component } from 'react'
import Error from '../layout/error.component'
import {
	StyledDiv,
	StyledInput,
	StyledLabel,
	StyledFieldContainer
} from './styled-input.style'

class HigherOrderField extends Component {
	constructor(props) {
		super(props)
		this.props = props
	}

	componentDidMount() {
		const { autoFocus, innerRef } = this.props
		if (autoFocus) innerRef && innerRef.current && innerRef.current.focus()
	}

	render() {
		const {
			id,
			full,
			icon,
			error,
			label,
			shadow,
			onFocus,
			touched,
			noBorder,
			className,
			information,
			submitCount,
			attribute
		} = this.props

		return (
			<StyledDiv id={`field-${id}`} className={className} full={full}>
				{typeof label === 'string' && label ? (
					<StyledLabel>
						<label htmlFor={id}>{label}</label>
					</StyledLabel>
				) : null}
				<StyledInput id={`select-${id}`} shadow={shadow} noBorder={noBorder}>
					<StyledFieldContainer
						className="input-container"
						onFocus={() => {
							if (attribute === 'passenger') onFocus(attribute)
						}}>
						{icon && icon()}
						{this.props.children}
						{information && information()}
					</StyledFieldContainer>
					{!!error && touched && submitCount > 0 ? (
						<Error className="error">{error}</Error>
					) : null}
				</StyledInput>
			</StyledDiv>
		)
	}
}

export default HigherOrderField
